const TickDouble01Icon = /*#__PURE__*/ [
  ["path", { d: "M3 13.3333C3 13.3333 4.5 14 6.5 17C6.5 17 6.78485 16.5192 7.32133 15.7526M17 6C14.7085 7.14577 12.3119 9.55181 10.3879 11.8223", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 13.3333C8 13.3333 9.5 14 11.5 17C11.5 17 17 8.5 22 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { TickDouble01Icon as default };
//# sourceMappingURL=TickDouble01Icon.js.map
